// src/Stack.tsx
import { Divider } from "@brexhq/metal-divider";
import styled from "@emotion/styled";
import { Children, Fragment, isValidElement, memo, useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var isFragment = (child) => isValidElement(child) && child.type === Fragment;
var Container = styled.div(
  ({
    direction,
    spacing,
    styleProps: {
      alignItems,
      justifyContent,
      wrap,
      shrink,
      grow,
      ...otherStyles
    }
  }) => ({
    ...otherStyles,
    alignItems,
    display: "flex",
    flexDirection: direction === "horizontal" ? "row" : "column",
    flexGrow: grow ? 1 : void 0,
    flexShrink: shrink ? 1 : void 0,
    flexWrap: wrap ?? "wrap",
    gap: spacing,
    justifyContent
  })
);
var Stack = memo(
  ({
    children,
    direction,
    spacing,
    hasDividers,
    divider,
    ...styleProps
  }) => {
    const safeDivider = useMemo(() => {
      if (divider) {
        return divider;
      }
      if (hasDividers) {
        return /* @__PURE__ */ jsx(Divider, {
          orientation: direction === "horizontal" ? "vertical" : "horizontal"
        });
      }
      return null;
    }, [direction, divider, hasDividers]);
    return /* @__PURE__ */ jsx(Container, {
      spacing,
      direction,
      styleProps,
      children: safeDivider ? Children.toArray(children).map(
        (c) => isFragment(c) ? c.props.children : c
      ).flat().filter((c) => c !== null && typeof c !== "undefined").map((child, i, arr) => /* @__PURE__ */ jsxs(Fragment, {
        children: [
          child,
          i < arr.length - 1 && safeDivider ? /* @__PURE__ */ jsx("div", {
            children: safeDivider
          }) : null
        ]
      }, i)) : children
    });
  }
);

// src/HStack.tsx
import { memo as memo2 } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var HStack = memo2(({ children, ...otherProps }) => /* @__PURE__ */ jsx2(Stack, {
  ...otherProps,
  direction: "horizontal",
  children
}));

// src/VStack.tsx
import { memo as memo3 } from "react";
import { jsx as jsx3 } from "react/jsx-runtime";
var VStack = memo3(({ children, ...otherProps }) => /* @__PURE__ */ jsx3(Stack, {
  ...otherProps,
  direction: "vertical",
  children
}));
export {
  HStack,
  Stack,
  VStack
};
